// Handle old Substack comment URLs
// Shows modal when redirected from a comment URL

(function() {
  'use strict';

  function handleCommentModal() {
    // Check if we're on a post page with the comment_missing parameter
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('comment_missing') === 'true') {
      showCommentMissingModal();
    }
  }

  function showCommentMissingModal() {
    // Create modal overlay
    const overlay = document.createElement('div');
    overlay.className = 'gh-comment-missing-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'comment-missing-title');
    
    // Create modal content
    const modal = document.createElement('div');
    modal.className = 'gh-comment-missing-modal';
    
    modal.innerHTML = `
      <div class="gh-comment-missing-content">
        <h2 id="comment-missing-title" class="gh-comment-missing-title">Comment No Longer Available</h2>
        <p class="gh-comment-missing-message">That comment no longer exists. Sorry for the inconvenience.</p>
        <button class="gh-button gh-button-primary gh-comment-missing-close" type="button">
          <span class="gh-button-content">Close</span>
        </button>
      </div>
    `;
    
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    
    // Focus management
    const closeButton = modal.querySelector('.gh-comment-missing-close');
    closeButton.focus();
    
    // Close handlers
    function closeModal() {
      // Remove query parameter from URL without page reload
      const url = new URL(window.location.href);
      url.searchParams.delete('comment_missing');
      window.history.replaceState({}, '', url);
      
      overlay.remove();
    }
    
    closeButton.addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeModal();
      }
    });
    
    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.parentNode) {
        closeModal();
      }
    });
    
    // Remove query parameter from URL
    const url = new URL(window.location.href);
    url.searchParams.delete('comment_missing');
    window.history.replaceState({}, '', url);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleCommentModal);
  } else {
    handleCommentModal();
  }
})();
